import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { FetchDataFn, PagingReactTable, QueryConfig } from "types";


export const CustomPaging = ({ pagination, fetchData }: { pagination: PagingReactTable, fetchData: FetchDataFn }) => {
    return (
        <section className="pagination-container">
            <div className="flex-space-between">
                <button className="btn-blue"
                    onClick={() => { fetchData({ paging: { ...pagination, currentPage: pagination.currentPage! - 1 } } as QueryConfig) }}
                    disabled={pagination.currentPage === 0}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    &nbsp;
                    <FormattedMessage id="REACT_TABLE_PREVIOUS" />
                </button>

                <div>
                    {pagination.currentPage + 1} / {pagination.totalPages}
                </div>

                <div className="pagination-rows-per-page">
                    <FormattedMessage id="REACT_TABLE_ROWS_PER_PAGE" />
                    <select value={pagination.pageSize}
                        onChange={(e) =>
                            fetchData({ paging: { ...pagination, pageSize: Number(e.target.value), currentPage: 0 } } as QueryConfig)}>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                    </select>
                </div>

                <button className="btn-blue"
                    onClick={() => { fetchData({ paging: { ...pagination, currentPage: pagination.currentPage! + 1 } } as QueryConfig) }}
                    disabled={pagination.currentPage + 1 === pagination.totalPages}>
                    <FormattedMessage id="REACT_TABLE_NEXT" />
                    &nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
        </section>
    )
}
